module.exports = { id: "frame-heren", url: "/build/app/img/symbols.svg#frame-heren", viewBox: "", toString: function() { return this.url; } };